"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _CircularLoader = require("../CircularLoader");
var _Input = require("../Input");
var _SearchInputModule = _interopRequireDefault(require("./SearchInput.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SearchInput = exports.SearchInput = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    value,
    disabled,
    locked,
    placeholder = 'Search...',
    classNames,
    onClear,
    isLoading,
    size,
    iconLeftName = 'magnifying-glass',
    testId,
    ...searchInputProps
  } = _ref;
  const handleClearClick = () => {
    if (value && !(disabled || locked)) {
      onClear?.();
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classify.default)(_SearchInputModule.default.searchInputWrapper, classNames?.wrapper),
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'wrapper'
    }),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.Input, {
      ...searchInputProps,
      type: "text",
      ref: ref,
      classNames: {
        iconRight: value && !(disabled || locked) ? _SearchInputModule.default.clickable : '',
        iconLeft: value && !disabled ? _SearchInputModule.default.primaryText : '',
        box: classNames?.box
      },
      placeholder: placeholder,
      value: value,
      disabled: disabled,
      locked: locked,
      iconLeftName: iconLeftName,
      size: size,
      iconRightName: value && !(disabled || locked) ? 'xmark' : 'fw',
      onIconRightClick: handleClearClick,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'input'
      })
    }), isLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.default)(_SearchInputModule.default.loaderContainer, {
        [_SearchInputModule.default.small]: size === 'small'
      }),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'loader-container'
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularLoader.CircularLoader, {
        colorToken: "colorFillPrimary",
        className: _SearchInputModule.default.loader,
        size: "small",
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'loader'
        })
      })
    })]
  });
});